import {connect} from 'react-redux';
import ClientInfoPanel from './ClientInfoPanel';
import { actions , selectors as businessCardSelectors } from "../../BusinessCard";

const { editClientInfo } = actions;
const { getBusinessCard } = businessCardSelectors;

const mapDispatchToProps = dispatch => ({
    onClientInfoEdit: (property, value) =>
      dispatch(editClientInfo(property, value))
  });
  
  const mapStateToProps = state => ({
    clientInfo: getBusinessCard(state).clientInfo,
  });

export default connect(mapStateToProps, mapDispatchToProps)(ClientInfoPanel);